import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-hot-toast";

const UserPofile = () => {
  const { authState } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/users`,
          {
            headers: { "x-auth-token": authState.token },
          }
        );
        setFormData({
          firstname: res.data.firstname,
          lastname: res.data.lastname,
          email: res.data.email,
          password: "",
        });
      } catch (err) {
        toast.error(err.response?.data?.msg || "Failed to fetch user profile");
      }
    };

    fetchUserProfile();
  }, [authState.token]);

  const { firstname, lastname, email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/profile`,
        formData,
        {
          headers: { "x-auth-token": authState.token },
        }
      );
      toast.success("Profile updated successfully!");
    } catch (err) {
      toast.error(err.response?.data?.msg || "Failed to update profile");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-black bg-opacity-50 z-50">
      <div className="w-full max-w-md p-8 bg-white dark:bg-black rounded shadow-md">
        <h1 className="mb-6 text-2xl font-bold text-center text-black dark:text-white">
          Update Profile
        </h1>
        <form onSubmit={onSubmit}>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <div>
              <label
                htmlFor="firstname"
                className="text-sm text-black dark:text-white"
              >
                First Name
              </label>
              <input
                id="firstname"
                type="text"
                className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
                placeholder="First Name"
                name="firstname"
                value={firstname}
                onChange={onChange}
                required
              />
            </div>
            <div>
              <label
                htmlFor="lastname"
                className="text-sm text-black dark:text-white"
              >
                Last Name
              </label>
              <input
                id="lastname"
                type="text"
                className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
                placeholder="Last Name"
                name="lastname"
                value={lastname}
                onChange={onChange}
                required
              />
            </div>
          </div>
          <div>
            <label htmlFor="email" className="text-sm text-black dark:text-white">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
              placeholder="Email"
              name="email"
              value={email}
              onChange={onChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="password"
              className="text-sm text-black dark:text-white"
            >
              Password (leave blank if unchanged)
            </label>
            <input
              id="password"
              type="password"
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
              placeholder="Password"
              name="password"
              value={password}
              onChange={onChange}
            />
          </div>
          <button
            type="submit"
            className="w-full mt-6 px-4 py-3 font-bold text-white bg-black dark:bg-white rounded hover:bg-gray-800 dark:hover:bg-gray-200 focus:outline-none focus:shadow-outline"
          >
            Update Profile
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserPofile;
